import { FETCH_ORDERS_REQUEST, FETCH_ORDERS_SUCCESS, FETCH_ORDERS_FAILURE, FETCH_ORDERS_RESET } from "../../actions";
const initialState = {
    fetchOrders: [],
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDERS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, fetchOrders: null });
        case FETCH_ORDERS_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchOrders: action.payload, isLoading: false, error: null });
        case FETCH_ORDERS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload, fetchOrders: null });
        case FETCH_ORDERS_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: null, error: null, fetchOrders: null });
        default:
            return state;
    }
};
export default reducer;
